import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ko from "@/locales/ko.json";
import en from "@/locales/en.json";
import mn from "@/locales/mn.json";
import zhCN from "@/locales/zh-CN.json";
import zhTW from "@/locales/zh-TW.json";
import vi from "@/locales/vi.json";

const resources = {
  ko: { translation: ko },
  en: { translation: en },
  mn: { translation: mn },
  "zh-CN": { translation: zhCN },
  "zh-TW": { translation: zhTW },
  vi: { translation: vi }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "ko", // Default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n;
